export default {
  props: {
    attrs: {
      type: Object,
      default: () => ({}),
    },
  },
}
